'use client';

import { ServerError } from '../src/views/ServerError/ServerError';

export default ServerError;
